import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-data-mining-create',
  templateUrl: './data-mining-create.component.html',
  styleUrls: ['./data-mining-create.component.css']
})
export class DataMiningCreateComponent implements OnInit {
    p2StatSourceKeyno;

    levelNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2StatSourceKeyno = this.stateService.getStateParams()['p2_statsource_keyno'];
        this.levelNo = this.stateService.getStateParams()['level_no'];
    }

    private async loadEdit() {
        if (!!this.p2StatSourceKeyno && !!this.levelNo) {
            this.edit = (await this.datatask.Post(821, {
                p2_statsource_keyno: this.p2StatSourceKeyno,
                level_no: this.levelNo
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(822, this.edit);

                this.stateService.go('datamininglist');
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_statsource_keyno: string;
    table_name: string;
    word_id_heading: string;
    word_id_description: string;
    statsource_heading: string;
    statsource_description: string;
    level_no: string;
}
